import React from 'react';
import { useSelector } from 'react-redux';
import { IntlShape, useIntl } from 'react-intl';

import ParkingFormType from 'types/ParkingForm';
import FormKeys from 'modules/form/types/FormKeys';
import { displayMobilityParking } from 'modules/selfServices/selectors';

import ParkingForm from './ParkingForm';
import ConnectedForm from '../ui/ConnectedForm';
import PageBaseProps from '../../types/PageBase';
import PopupErrorForm from '../Errors/PopupErrorForm';

const validateForm = (intl:IntlShape)=>(values:ParkingFormType) => ({
  spotNumber: values.x || values.spotNumber ? undefined : intl.formatMessage({
    id: 'validation.required',
    defaultMessage: 'Please answer to continue.',
  }),
});

const Parking: React.FC<PageBaseProps> = ({
  onNext, onPrev, isPenultimate, shouldDisplayBackButton,
}) => {
  const isMobility = useSelector(displayMobilityParking);
  const intl = useIntl();
  return (
    <ConnectedForm
      onPrev={onPrev}
      onSubmit={onNext}
      validate={validateForm(intl)}
      keepDirtyOnReinitialize
      component={ParkingForm}
      isPenultimate={isPenultimate}
      shouldDisplayBackButton={shouldDisplayBackButton}
      formKey={isMobility ? FormKeys.MOBILITY_PARKING : FormKeys.PARKING}
      errorComponent={<PopupErrorForm errorMessage={{
        id: 'parking.mandatoryModal.title',
        defaultMessage: 'You must first enter your parking spot number or point it on the map',
      }} />}
      subscription={{ hasValidationErrors: true, errors: true }}
    />
  );
};
export default Parking;
